"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDaysWithUnifiedMissedPunch = exports.useDaysWithMissedPunch = void 0;
const luxon_1 = require("luxon");
const useDaysWithMissedPunch = ({ punchesTimeSegments }) => {
    return ((punchesTimeSegments === null || punchesTimeSegments === void 0 ? void 0 : punchesTimeSegments.filter((punch) => !punch.startDateTime || !punch.endDateTime).map((punch) => {
        if (punch.startDateTime) {
            return luxon_1.DateTime.fromISO(punch.startDateTime);
        }
        if (punch.endDateTime) {
            return luxon_1.DateTime.fromISO(punch.endDateTime);
        }
        return null;
    }).filter((dateTime) => !!dateTime)) || []);
};
exports.useDaysWithMissedPunch = useDaysWithMissedPunch;
const useDaysWithUnifiedMissedPunch = ({ punchWithTimespans }) => {
    const daysWithMissedPunch = new Set();
    const missedPunchWithTimespans = punchWithTimespans.filter((punchWithTimespan) => {
        var _a, _b;
        return !((_a = punchWithTimespan.startSpan) === null || _a === void 0 ? void 0 : _a.punchDateTime) ||
            !((_b = punchWithTimespan.endSpan) === null || _b === void 0 ? void 0 : _b.punchDateTime);
    });
    missedPunchWithTimespans.forEach((punchWithTimespan) => {
        var _a, _b;
        if ((_a = punchWithTimespan.startSpan) === null || _a === void 0 ? void 0 : _a.punchDateTime) {
            const punchDate = luxon_1.DateTime.fromISO(punchWithTimespan.startSpan.punchDateTime.timestamp);
            daysWithMissedPunch.add(punchDate);
        }
        if ((_b = punchWithTimespan.endSpan) === null || _b === void 0 ? void 0 : _b.punchDateTime) {
            const punchDate = luxon_1.DateTime.fromISO(punchWithTimespan.endSpan.punchDateTime.timestamp);
            daysWithMissedPunch.add(punchDate);
        }
    });
    return Array.from(daysWithMissedPunch);
};
exports.useDaysWithUnifiedMissedPunch = useDaysWithUnifiedMissedPunch;
